import React from "react";
import { Route, Routes } from "react-router-dom";
import { notification } from "antd";
import { useClient } from "../Context/ClientContext";
import { NotificationPlacement } from "antd/es/notification/interface";
import DashboardTemplate from "../Template/DashboardTemplate";
import VendorDashboard from "../Pages/Vendors/VendorDashboard/VendorDashboard";
import VendorWebPage from "../Pages/Vendors/VendorWebPage/VendorWebPage";
import { useUser } from "../../Context/UserContext";

export type NotificationType = "success" | "info" | "warning" | "error";
export const notificationContext = React.createContext<any>({});
const VendorPageRoute = () => {
  const { currentClient, estimatehide } = useClient();
  const { getUser } = useUser();
  let loginUser = { ...getUser() };
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (
    type: NotificationType,
    message: string,
    description?: string,
    duration?: number,
    closeIcon?: boolean,
    placement?: NotificationPlacement,
    icon?: any
  ) => {
    api[type]({
      message: message,
      description: description,
      duration: duration ? duration : 4,
      // closeIcon: closeIcon ? false : <CloseOutlined  />,
      style: {
        marginTop: "23px",
        padding: "15px 12px 7px 15px",
      },
      placement: placement,
      icon: icon,
    });
  };

  return (
    <notificationContext.Provider value={{ openNotification }}>
      <>
        {/* <React.Suspense fallback={<FullPageSpinner />}> */}
        <Routes>
         
          <Route
            path={`/clients/${loginUser?.id}/dashboard`}
            element={
              <DashboardTemplate
                element={<VendorDashboard />}
                // breadcrumprops={[
                //   {
                //     item: "Client",
                //     path: `/vendor/dashboard`,
                //   },
                //   {
                //     item: "Vendor",
                //   },
                // ]}
              />
            }
          />
        </Routes>
      </>
    </notificationContext.Provider>
  );
};

export default VendorPageRoute;
